import storage from "redux-persist/lib/storage";

// The clean-up a sign-out does, in one place: used by the Log out page
// (containers/PrivateRoutes/Logout) and, in the desk build, by the wrong-
// account guard (components/DeskAccountGuard).
//
// `logout` and `resetOrder` are the redux actions to dispatch. With
// keepPhone the phone number used to sign in stays in localStorage, so the
// Sign In page offers it again (the normal Log out). The desk guard passes
// false: that phone belongs to the wrong account.
export const signOutCleanup = ({ logout, resetOrder, keepPhone }) => {
  const phone_number = localStorage.getItem('phone_number');

  const removePersistRoot = async () => {
    console.log("lets remove persist:root")
    localStorage.removeItem("persist:root")
    await storage.removeItem("persist:root");
  }

  const clearApiCache = async () => {
    await caches.delete('endpoints-cache')
    await caches.delete('images-cache')
  }

  logout();
  localStorage.clear();
  removePersistRoot()
  localStorage.removeItem("employee_ordering_for")
  clearApiCache()
  resetOrder()
  if (keepPhone && phone_number) localStorage.setItem('phone_number', phone_number)
};
